import React, { Component } from "react";
import { I18n } from "react-redux-i18n";
import "../../../styles/components/ceme/sections/Tariff.scss";
import discountImage from "../../../styles/images/ceme/discount-25.png";
import energy from "../../../styles/images/icons/energy.svg";
import gas from "../../../styles/images/icons/gas.svg";
import GOOGLE from "../../../styles/images/google.png";
import APPLE from "../../../styles/images/apple.png";
import {requestMetaConversionAPI} from '../../utils/Utils'

class Tariff extends Component {
  constructor(props) {
    super(props);
    this._mounted = false;
    this.cancel = null;

    this.state = {
      translationKeys: false,
    };
  }

  //Splits data by ";" to make sure <span> and <p> are done in the render
  handleTranslationKeys() {
    const splittedKeys = {
      title: [
        I18n.t("siteCeme_tariff_card1_title"),
        I18n.t("siteCeme_tariff_card2_title"),
        I18n.t("siteCeme_tariff_card3_title"),
      ],

      subTitle: [
        I18n.t("siteCeme_tariff_card1_subtitle"),
        I18n.t("siteCeme_tariff_card2_subtitle"),
        I18n.t("siteCeme_tariff_card3_subtitle"),
      ],

      bottom: [
        I18n.t("siteCeme_tariff_card1_bottom").split(";"),
        I18n.t("siteCeme_tariff_card2_bottom").split(";"),
        I18n.t("siteCeme_tariff_card3_bottom").split(";"),
      ],

      text: [
        I18n.t("siteCeme_tariff_card1_text").split(";"),
        I18n.t("siteCeme_tariff_card2_text").split(";"),
        I18n.t("siteCeme_tariff_card3_text").split(";"),
      ],

      bottomTitle: I18n.t("siteCeme_tariff_bottom_title"),

      bottomText: I18n.t("siteCeme_tariff_bottom_text").split(";"),
    };

    this.safeSetState({ translationKeys: splittedKeys });
  }

  componentDidMount() {
    this._mounted = true;
    this.handleTranslationKeys();
  }

  componentWillUnmount() {
    if (this.cancel !== null) this.cancel("Component is unmounting");
    this._mounted = false;
  }

  safeSetState(params, callback) {
    if (this._mounted) this.setState(params, callback);
  }

  render() {
    return this.state.translationKeys ? (
      <div id="tariff">
        <div className="content-section">
          <div className="content">
            <div className="item top">
              <div className="special-title">
                <div className="left">TARIFÁRIO</div>
              </div>
              <div>
                <div
                  style={{
                    height: "20px",
                    width: "2px",
                    backgroundColor: "#2FFFD1",
                    display: "inline-block",
                    marginRight: "10px",
                    verticalAlign: "middle",
                  }}
                ></div>
                <span
                  style={{ display: "inline-block", verticalAlign: "middle" }}
                >
                  Simule na app o preço total, antes do carregamento
                </span>
              </div>
            </div>

            <div className="item body">
              <div className="break" />
              <div className="tariff-item">
                <div className="tariff-content">
                  <div className="top">
                    <div className="left">
                      <img src={energy} alt="icon" />
                    </div>
                    <div className="right">
                      <div className="title">
                        {this.state.translationKeys.title[0]}
                      </div>
                      <div className="sub-title">
                        {this.state.translationKeys.subTitle[0]}
                      </div>
                    </div>
                  </div>
                  <div className="body">
                    <div>
                      <span>
                        <span className="price">0,169</span> €/kWh <br />
                        <span>
                          em Vazio <span>&#127769;</span> ou Fora de Vazio ☀️
                        </span>
                      </span>
                    </div>
                    <br />
                    <div>
                      <span>
                        {" "}
                        + <span className="price">0,15</span> €/carregamento
                      </span>
                    </div>
                    <br />
                    <div style={{ display: "flex", justifyContent: "center" }}>
                      <p
                        style={{
                          lineHeight: "1",
                          textAlign: "center",
                          fontSize: "20px",
                        }}
                      >
                        {this.state.translationKeys.text[0].map((item, idx) => {
                          if (idx === this.state.translationKeys.text.length) {
                            return (
                              <span key={idx}>
                                {item}
                                <sub>2</sub>
                              </span>
                            );
                          } else {
                            return <span key={idx}>{item}</span>;
                          }
                        })}
                        <a
                          href="mailto:sales@go-evio.com"
                          alt="Consultar tarifa"
                          className="tariff-link"
                        >
                          {I18n.t("siteCeme_tariff_card1_link")}
                        </a>
                      </p>
                    </div>
                    <br />
                    <p>
                      {this.state.translationKeys.bottom[0].map((item, idx) => {
                        if (
                          idx !==
                          this.state.translationKeys.bottom[0].length - 1
                        )
                          return <span key={idx}>{item}</span>;
                        else
                          return (
                            <>
                              <span className="price-info" key={idx}>
                                {I18n.t("siteCeme_tariff_card1_bottom_1")}
                                {I18n.t("siteCeme_tariff_card1_bottom_3")}
                                <br />
                                {I18n.t("siteCeme_tariff_card1_bottom_2")}{" "}
                                <a
                                  href="https://www.erse.pt/media/wijn0vgt/periodos-hor%C3%A1rios-de-energia-el%C3%A9trica-em-portugal.pdf"
                                  target="_blank"
                                  rel="noreferrer"
                                >
                                  disponíveis na ERSE
                                </a>
                              </span>
                            </>
                          );
                      })}
                    </p>
                  </div>
                </div>
              </div>

              <div className="tariff-item">
                <div className="tariff-content">
                  <div className="top">
                    <div className="left">
                      <img src={gas} alt="icon" />
                    </div>
                    <div className="right">
                      <div className="title">
                        {this.state.translationKeys.title[1]}
                      </div>
                      <div className="sub-title">
                        {this.state.translationKeys.subTitle[1]}
                      </div>
                    </div>
                  </div>
                  <div className="body">
                    <p>
                      {this.state.translationKeys.text[1].map((item, idx) => {
                        return <span key={idx}>{item}</span>;
                      })}
                    </p>
                    <div className="store-links">
                      <a
                        href="https://play.google.com/store/apps/details?id=com.evio.evio&pli=1"
                        target="_blank"
                        rel="noreferrer"
                        onClick={() => requestMetaConversionAPI("android")}
                      >
                        <img src={GOOGLE} alt="Google" />
                      </a>
                      <a
                        href="https://apps.apple.com/pt/app/evio/id1539284689"
                        target="_blank"
                        rel="noreferrer"
                        onClick={() => requestMetaConversionAPI("ios")}
                      >
                        <img src={APPLE} alt="Apple" />
                      </a>
                    </div>
                  </div>
                  <p>
                    {this.state.translationKeys.bottom[1].map((item, idx) => {
                      return <span key={idx}>{item}</span>;
                    })}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    ) : null;
  }
}

export default Tariff;
